import { equals, propEq } from 'ramda';

export const roleEq = propEq('role');
export const equalsSuperadmin = equals('superadmin');
